<template>
  <div class="lay" v-loading="loading">
    <div class="row" v-for="item in datas" :key="item.id"
    @click="handleRow(item)">
      <div>{{item.name}}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    datas: Array,
    loading: Boolean
  },
  data() {
    return {
    }
  },
  methods: {
    handleRow(item) {
      this.$emit('onRow', item)
    }
  }
}
</script>

<style lang="scss" scoped>
.lay {
  max-height: 50vh;
  overflow: auto;
}
.row {
  padding: 10px 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.row:hover {
  background-color: #f5f5f5;
}
</style>
